import styled from '@emotion/styled';
import { Form as FormikForm } from 'formik';
import { FormControlLabel, Typography } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};
interface ContainerProps {
  theme: ICustomTheme;
  isMobile: boolean;
}

export const StyledContainer = styled('div')<Theme>`
  margin-top: ${({ theme }) => theme.spacing(5)}px;
  display: flex;
  flex-direction: column;
`;

export const StyledTitle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<ContainerProps>`
  font-weight: bold;
  font-size: ${({ isMobile }) => (isMobile ? 24 : 30)}px;
`;

export const StyledRecommandationsBlock = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<ContainerProps>`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
  font-size: ${({ isMobile }) => (isMobile ? 14 : 16)}px;
  background-color: #eee;
  box-sizing: content-box;
`;

export const StyledRecommandationsBlockTitle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<ContainerProps>`
  margin: ${({ theme, isMobile }) =>
    isMobile ? theme.spacing(1) : theme.spacing(2)}px;
  font-weight: bold;
`;

export const StyledRecommandationsContent = styled('div')<Theme>`
  height: 100%;
  display: flex;
  flex-wrap: wrap;

  > ul {
    margin-top: 0;
  }
`;

export const Form = styled(FormikForm)<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
  maxWidth: theme.spacing(60),
}));

export const CheckboxFormControl = styled(FormControlLabel)({
  marginLeft: 0,
});

export const Error = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.error.main,
}));

export const SubmitButtonContainer = styled.div<Theme>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(4, 0),
}));

export const ConnectMessageContainer = styled.div({
  textAlign: 'center',
});
